import videojs from 'video.js';
import './events-on-timeline.js';
import './videojs-events-on-timeline.scss';

/**
 * Default options for the plugin.
 * @typedef {Object} Options
 * @property {string} eventsUrl
 * @property {Function} getIconUrl
 * @property {number} pollingInterval
 * @property {number} startBroadcast
 * @property {boolean} isAvailable
 * @property {function} requestAccess
 */
const defaults = {
	eventsUrl: '',
	getIconUrl: () => { },
	pollingInterval: 60000,
	startBroadcast: 0,
	isAvailable: true,
	requestAccess: () => {}
};

class EventsOnTimeline extends videojs.getPlugin('plugin') {
	/**
	 * @param {import("video.js").VideoJsPlayer} player
	 * @param {Options} opts
	 */
	constructor(player, opts) {
		super(player);
		this.options = videojs.mergeOptions(defaults, opts);
		this.init();
	}

	init() {
		this.player.ready(() => {
			const controlBar = this.player.getDescendant(['controlBar']);
			if (!controlBar) return;
			this.player.addClass('vjs-events-on-timeline');
			controlBar.addChild('EventsOnTimeline', this.options);
		});
	}
}

videojs.registerPlugin('eventsOnTimeline', EventsOnTimeline);
